export default "__VITE_ASSET__CGSt73Zm__"